<template>
  <div class="form-group">
    <label class="typo__label">Pige</label>
    <multiselect
      v-model="value"
      tag-placeholder="Add this as new tag"
      placeholder="Ajouter un code postal"
      label="name"
      track-by="code"
      :options="options"
      :multiple="true"
      :taggable="true"
      :hideSelected="true"
      :showNoResults="false"
      :maxHeight="0"
      @tag="addTag"
      @remove="removeTag">
    </multiselect>
    <span class="invalid-feedback d-block" role="alert" v-if="error">
        <strong>{{ error }}</strong>
    </span>
    <input v-for="pige in zipcode" :key="pige" :value="pige" name="pige[]" type="text" style="display: none;">
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },

  props: {
    pige: {
      default: [],
      type: Array,
    },
    serverError: String,
  },

  data () {
    return {
      value: [],
      options: [],
      zipcode: [],
      error: ''
    }
  },
  methods: {
    addTag (newTag) {
      if (this.validTag(newTag)) {
        const tag = {
          name: newTag,
          code: newTag
        }
        this.value.push(tag)
        this.zipcode.push(newTag)
        this.error = ''
      }
    },

    removeTag(tag) {
      if (this.zipcode.includes(parseInt(tag.code))) {
        this.zipcode.splice(this.zipcode.indexOf(parseInt(tag.code)), 1);
      }

      if (this.value.includes(tag)) {
        this.value.splice(this.value.indexOf(tag), 1);
      }
    },

    validTag(tag) {
      if (tag.length > 0 && tag.length === 5) {
        return true
      }

      return false
    }
  },

  mounted() {
    if (this.pige && this.pige.length > 0) {
      for (let i = 0; i < this.pige.length; i++) {
        this.addTag(this.pige[i])
      }
    }

    if (this.serverError) {
      this.error = this.serverError
    }
  }
}
</script>
